import { AiseaApiFactory } from "@/api/aisea/apiFactory";
import SecureDataflowService from "@/services/secureDataflowService";
const epVesselSdfChannel = AiseaApiFactory.get(
  "enterpriseVesselSecureDataflowChannel"
);
const EnterpriseVesselApi = AiseaApiFactory.get("enterpriseVessel");

export default {
  async setVesselInfoAndVersions({ commit }, payload) {
    const resManeuveringVersion = await epVesselSdfChannel.getChannelVersions(
      payload.vesselInfo.id,
      { origin: payload.maneuveringOriginId, kind: "handling" }
    );
    const resEngineVersion = await epVesselSdfChannel.getChannelVersions(
      payload.vesselInfo.id,
      { origin: payload.engineOriginId, kind: "engine" }
    );
    const resAlertVersion = await epVesselSdfChannel.getChannelVersions(
      payload.vesselInfo.id,
      { origin: payload.alertOriginId, kind: "aisea_alert" }
    );

    if (!resManeuveringVersion.status) {
      return resManeuveringVersion;
    }

    if (!resEngineVersion.status) {
      return resManeuveringVersion;
    }

    if (!resAlertVersion.status) {
      return resAlertVersion;
    }

    commit("SET_MANEUVERING_VERSION", {
      id: resManeuveringVersion.data.version_id,
      name: resManeuveringVersion.data.version_name
    });

    commit("SET_ENGINE_VERSION", {
      id: resEngineVersion.data.version_id,
      name: resEngineVersion.data.version_name
    });

    commit("SET_ALERT_VERSION", {
      id: resAlertVersion.data.version_id,
      name: resAlertVersion.data.version_name
    });

    await SecureDataflowService.saveVessel(payload);

    commit("SET_VESSEL_INFO", payload.vesselInfo);

    return { status: true };
  },

  async setChannelMaster({ commit }, payload) {
    let res = await epVesselSdfChannel.getChannels(
      payload.vesselId,
      payload.params
    );
    await SecureDataflowService.saveChannelMaster({
      channelMaster: res.data.channels
    });
    commit("SET_CHANNEL_MASTER", res.data.channels);
  },

  async setOwnVessels({ commit }) {
    let payload = {
      is_disabled: false,
      is_deleted: false,
      page: 0,
      limit: 200
    };
    let res = await EnterpriseVesselApi.search(payload);
    commit("SET_OWN_VESSELS", res.data.vessels);
  },

  resetSdfCommonState({ commit }) {
    let defaultState = {
      vesselInfo: null
    };
    commit("RESET_STATE", defaultState);
  }
};
